import React from 'react'
import { Button, Col, Form } from 'react-bootstrap'

import { reticenciasVerde } from '../../../utils/alternanciaIcones'

export default function CardHeader({
  titulo,
  nomeOpcao,
  portalCliente,
  handleAbrirMenuOpcoes
}) {
  return (
    <Form.Row>
      <Col>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Form.Label>
            <div className="fonte-cor-1 label-janela-dashboard-3">{titulo}</div>
          </Form.Label>

          {!portalCliente && (
            <Button
              className="botao-opcoes"
              variant="danger"
              onClick={() => handleAbrirMenuOpcoes(nomeOpcao)}
            >
              <img
                className="bota-opcoes-icone"
                src={reticenciasVerde()}
                alt="opções"
              />
            </Button>
          )}
        </div>
      </Col>
    </Form.Row>
  )
}
